"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentType = void 0;
exports.ConsentType = {
    TermsOfUse: "terms-of-use",
    TelehealthInformedConsent: "telehealth-informed-consent",
    MobileTermsAndConditions: "mobile-terms-and-conditions",
    NoticeOfPrivacyPractices: "notice-of-privacy-practices",
    PrivacyPolicy: "privacy-policy",
    HipaaAuthorization: "hipaa-authorization",
};
